import { schema } from "normalizr";
import { ModuleArraySchema } from "./modules";

const AppsSchema = new schema.Entity("apps", {
  modules: ModuleArraySchema
});

const AppsArraySchema = new schema.Array(AppsSchema);

export { AppsSchema, AppsArraySchema };